import React from 'react';
import useReveal from '../hooks/useReveal';

const Reveal = ({ children, delay = 0, y = 24, className = '' }) => {
  const [ref, visible] = useReveal();
  return (
    <div
      ref={ref}
      style={{
        transform: visible ? 'translateY(0)' : `translateY(${y}px)`,
        opacity: visible ? 1 : 0,
        transition: `transform 0.9s cubic-bezier(0.22,1,0.36,1) ${delay}ms, opacity 0.9s ease ${delay}ms`,
      }}
      className={className}
    >
      {children}
    </div>
  );
};

export default Reveal;
